import { getCSRFToken } from './utils'
import { RequestOptions, TrackedMutationOptions } from './api'

type PutApi = { put: (path: string, body: unknown, options?: RequestOptions) => Promise<unknown> }

/** Shared by the admin Users list and the admin organisation's users table. */
export async function setUserAdminLocked(api: PutApi, userId: string, locked: boolean, options?: TrackedMutationOptions) {
    const csrf = options?.signal ? await getCSRFToken(options.signal) : await getCSRFToken()
    if (options?.signal?.aborted) throw new DOMException('The operation was aborted.', 'AbortError')
    options?.onSubmitted?.()
    const body = {
        user: {
            adminLocked: locked,
        },
        _csrf: csrf,
    }
    if (options) {
        await api.put(`/admin/user/${userId}`, body, { signal: options.signal })
    } else {
        await api.put(`/admin/user/${userId}`, body)
    }
}
